export class BuscarProcessosModel {
  public FiltroDescricao: string;
  public FiltroCampo: string;
  public Pagina: number;
  
  public NomeCliente: string;
  public Ficha: string;
  public CPF: string;
  public NumeroAutos: string;
  public NomeParteContraria: string;
  public OutrosAutores: string;
  public NaturezaDeAcao: number;
  public Arquivados: boolean;

  public ClienteIdResumo: number | null;
  public ClienteNomeResumo: string | null;

  constructor(){
    this.FiltroDescricao = "";
    this.FiltroCampo = "";
    this.Pagina = 0;
    this.NomeCliente = "";
    this.Ficha = "";
    this.CPF = "";
    this.NumeroAutos = "";
    this.NomeParteContraria = "";
    this.OutrosAutores = "";
    this.NaturezaDeAcao = 0;
    this.Arquivados = false;
  }
}
